<!-- 悬浮按钮 -->
<template>
  <div class="ke_ConMenu">
    <div class="more_show_box" style="--boxwidth:160px">
      <div class="more_show">
        0731-85303809
      </div>
      <div class="keCon_icon">
        <i class="el-icon-phone"></i>
      </div>
    </div>
    <div class="more_show_box" style="--boxwidth:220px">
      <div class="more_show e-mail">
       csyicedianzi@csyice.com
      </div>
      <div class="keCon_icon">
        <svg t="1655346450639" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6888" width="14" height="14"><path d="M838.954667 234.666667H170.666667c-3.626667 0-7.168 0.448-10.56 1.322666l323.690666 323.669334a21.333333 21.333333 0 0 0 30.165334 0L838.954667 234.666667z m46.144 14.186666l-260.693334 260.693334 262.933334 262.912c5.44-7.168 8.661333-16.106667 8.661333-25.792V277.333333c0-10.944-4.117333-20.906667-10.88-28.48zM843.861333 789.333333l-249.6-249.621333-50.133333 50.133333a64 64 0 0 1-90.517333 0l-50.112-50.133333L156.373333 786.88c4.48 1.578667 9.28 2.453333 14.314667 2.453333h673.194667zM128.661333 754.218667L373.333333 509.525333 129.578667 265.813333A42.709333 42.709333 0 0 0 128 277.333333v469.333334c0 2.56 0.213333 5.098667 0.661333 7.552zM170.666667 192h682.666666a85.333333 85.333333 0 0 1 85.333334 85.333333v469.333334a85.333333 85.333333 0 0 1-85.333334 85.333333H170.666667a85.333333 85.333333 0 0 1-85.333334-85.333333V277.333333a85.333333 85.333333 0 0 1 85.333334-85.333333z" fill="#ffffff" p-id="6889"></path></svg>
      </div>
    </div>
        <div class="more_show_box">
      <!-- <div class="more_show">
        <span>0731-85303809</span>
      </div> -->
      <div class="keCon_icon" @click="go_top()">
        <i class="el-icon-arrow-up"></i>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
    };
  },

  components: {},

  computed: {},

  mounted () {

  },

  methods: {
    go_top () {
      //   console.log(this.$parent)
      this.$parent.go_top()
    }
  }
}

</script>
<style scoped>
.ke_ConMenu {
  height: 190px;
  width: 40px;
  margin-top: -95px;
  position: fixed;
  top: 50%;
  right: 20px;
  z-index: 30;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-end;
  z-index: 10000;
}
.more_show_box {
  position: relative;
  width: 40px;
  height: 40px;
  font-size: 13px;
  border-radius: 40px;
}
.keCon_icon {
  background: rgba(0, 0, 0, 0.3);
  display: block;
  border-radius: 50%;
  line-height: 40px;
  text-align: center;
  height: 40px;
  width: 40px;
  cursor: pointer;
  color: #fff;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;
    transition: background-color 0.5s;
}

.more_show_box:hover .keCon_icon{
  background: #004ea2;
}
.more_show {
  /* display: flex;
    justify-content: flex-end; */
  position: absolute;
  top: 0;
  right: 0;
  background: #004ea2;
  color: #fff;
  height: 40px;
  width: 40px;
  border-radius: 40px;
  transition: all 0.5s;
  overflow: hidden;
  opacity: 0;
  text-align: left;
    padding-left: 20px;
    line-height: 40px;
}
.more_show_box:hover .more_show {

  width:var(--boxwidth);
  opacity: 1;
}
.more_show:hover{
  width:var(--boxwidth);
  opacity: 1;
}
.more_show span {
  display: block;
  width: 200px;
  height: 40px;
  line-height: 40px;
  padding-left: 30px;

}
</style>
